<template>
  <base-form-detail
    :controller="controller"
    :readonly="readonly"
    :source="source"
    @close="$emit('close')"
    @save="$emit('save')"
  >
    <entity-card-user-management-users-detail-account-information
      :care-partners="lists.carePartners"
      :monitors="lists.monitors"
      :readonly="readonly"
      :source="source"
      :user-types="lists.userTypes"
    />
    <entity-card-user-management-users-detail-contact-details
      :codes="contentMixin.codes"
      :posts="lists.posts"
      :readonly="readonly"
      :source="source"
    />
    <entity-card-user-management-users-detail-extra-information
      :readonly="readonly"
      :source="source"
    />
  </base-form-detail>
</template>

<script>
import BaseFormDetail from '@/components/shared/base/base-form-detail'
import EntityCardUserManagementUsersDetailAccountInformation from '@/components/shared/entitycards/entity-card-user-management-users-detail-account-information'
import EntityCardUserManagementUsersDetailContactDetails from '@/components/shared/entitycards/entity-card-user-management-users-detail-contact-details'
import EntityCardUserManagementUsersDetailExtraInformation from '@/components/shared/entitycards/entity-card-user-management-users-detail-extra-information'
import BaseFormDetailMixin from '@/mixins/base-form-detail-mixin'

export default {
  name: 'UserManagementUsersDetail',
  components: {
    BaseFormDetail,
    EntityCardUserManagementUsersDetailContactDetails,
    EntityCardUserManagementUsersDetailExtraInformation,
    EntityCardUserManagementUsersDetailAccountInformation
  },
  mixins: [
    BaseFormDetailMixin
  ],
  data () {
    return {
      controller: 'User',
      lists: {
        carePartners: [],
        monitors: [],
        posts: [],
        userTypes: []
      }
    }
  },
  mounted () {
    this.Initialize()
  },
  methods: {
    async Initialize () {
      await this.BaseFormDetailMixin_Initialize(this.controller)
      await this.ContentMixin_Service_BC_InitializeCodes()
      this.lists.carePartners = await this.ContentMixin_Service_BC_PickSource('CarePartner')
      this.lists.monitors = await this.ContentMixin_Service_BC_PickSource('Monitor')
      this.lists.posts = await this.ContentMixin_Service_BC_PickSource('Post')
      this.lists.userTypes = await this.ContentMixin_Service_BC_PickSource('UserType')
    }
  }
}
</script>
